import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../assets/img/logo-transparent.png";

import { UserIcon } from "../components/Icons/UserIcon";
import { ServicesIcon } from "../components/Icons/ServicesIcon";
import { QuestionIcon } from "../components/Icons/QuestionIcon";
import { LogoutIcon } from "../components/Icons/LogoutIcon";
import { HomeIcon } from "../components/Icons/HomeIcon";
import { HelpIcon } from "../components/Icons/HelpIcon";

import { useAuth } from "../hooks";
import { ROLES } from "../utils";

import "../assets/css/modern-dashboard.css";

export const Sidebar = ({ user }) => {
  const { logOut } = useAuth();
  const { pathname } = useLocation();

  const linkClass = (path) =>
    `modern-nav-link ${pathname === path ? "active" : ""}`;

  return (
    <aside className="sidebar modern-sidebar">

      <Link to="/" className="modern-sidebar-brand">

        <div className="modern-brand-logo">
          <img
            src={logo}
            alt="Proceso Seguro"
          />
        </div>

      </Link>

      <div className="modern-sidebar-section">

        <span className="modern-sidebar-label">
          PRINCIPAL
        </span>

        <nav className="modern-sidebar-nav">

          <NavLink
            to="/"
            className={linkClass("/")}
          >
            <span className="modern-nav-icon">
              <HomeIcon />
            </span>

            <span>
              Mis cursos
            </span>
          </NavLink>

          {user.roleId === ROLES.admin && (
            <NavLink
              to="/servicios"
              className={linkClass("/servicios")}
            >
              <span className="modern-nav-icon">
                <ServicesIcon />
              </span>

              <span>
                Prev-cursos
              </span>
            </NavLink>
          )}

        </nav>

      </div>

      <div className="modern-sidebar-section modern-sidebar-support">

        <span className="modern-sidebar-label">
          SOPORTE
        </span>

        <nav className="modern-sidebar-nav">

          <NavLink
            to="/help"
            className={linkClass("/help")}
          >
            <span className="modern-nav-icon">
              <HelpIcon />
            </span>

            <span>
              Ayuda
            </span>
          </NavLink>

          <NavLink
            to="/faq"
            className={linkClass("/faq")}
          >
            <span className="modern-nav-icon">
              <QuestionIcon />
            </span>

            <span>
              Preguntas frecuentes
            </span>
          </NavLink>

        </nav>

      </div>

      <div className="modern-sidebar-bottom">

        <NavLink
          to="/profile"
          className={linkClass("/profile")}
        >
          <span className="modern-nav-icon">
            <UserIcon />
          </span>

          <span>
            Mi perfil
          </span>
        </NavLink>

        <Link
          to="/login"
          onClick={logOut}
          className="modern-nav-link modern-logout"
        >
          <span className="modern-nav-icon">
            <LogoutIcon />
          </span>

          <span>
            Salir
          </span>
        </Link>

      </div>

    </aside>
  );
};